import { useState } from 'react';
import { Navbar, Footer, BookingModal } from '@/components/feature';
import HeroSection from './components/HeroSection';
import PromiseBar from './components/PromiseBar';
import ServicesSection from './components/ServicesSection';
import AppAdSection from './components/AppAdSection';
import ProcessSection from './components/ProcessSection';
import TrustSafetySection from './components/TrustSafetySection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar onBookCleanup={() => setBookingOpen(true)} />
      <main>
        <HeroSection onBookCleanup={() => setBookingOpen(true)} />
        <PromiseBar />
        <ServicesSection />
        <AppAdSection />
        <ProcessSection />
        <TrustSafetySection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
    </div>
  );
}